var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWashingMaschine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M246.774,0l-193.548,0c-13.342,0 -24.194,10.852 -24.194,24.194l0,251.612c0,13.342 10.852,24.194 24.194,24.194l193.548,0c13.342,0 24.194,-10.852 24.194,-24.194l-0,-251.612c-0,-13.342 -10.852,-24.194 -24.194,-24.194Zm14.516,275.806c0,8.004 -6.513,14.517 -14.516,14.517l-193.548,-0c-8.003,-0 -14.516,-6.513 -14.516,-14.517l-0,-251.612c-0,-8.004 6.513,-14.517 14.516,-14.517l193.548,0c8.003,0 14.516,6.513 14.516,14.517l0,251.612Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,96.774c-47.135,0 -85.484,38.349 -85.484,85.484c0,47.136 38.349,85.484 85.484,85.484c47.135,-0 85.484,-38.348 85.484,-85.484c-0,-47.135 -38.349,-85.484 -85.484,-85.484Zm0,161.291c-41.8,-0 -75.806,-34.007 -75.806,-75.807c-0,-41.8 34.006,-75.806 75.806,-75.806c41.8,-0 75.806,34.006 75.806,75.806c0,41.8 -34.006,75.807 -75.806,75.807Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,110.216c-39.726,0 -72.042,32.319 -72.042,72.042c0,39.723 32.319,72.042 72.042,72.042c39.723,0 72.042,-32.319 72.042,-72.042c-0,-39.726 -32.319,-72.042 -72.042,-72.042Zm0,134.407c-34.39,-0 -62.365,-27.978 -62.365,-62.365c0,-34.39 27.978,-62.364 62.365,-62.364c34.387,-0 62.365,27.977 62.365,62.364c-0,34.387 -27.978,62.365 -62.365,62.365Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.355,41.935l16.129,0c2.674,0 4.839,-2.164 4.839,-4.838c-0,-2.674 -2.165,-4.839 -4.839,-4.839l-16.129,0c-2.674,0 -4.839,2.165 -4.839,4.839c0,2.674 2.165,4.838 4.839,4.838Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.613,41.935l16.129,0c2.674,0 4.839,-2.164 4.839,-4.838c-0,-2.674 -2.165,-4.839 -4.839,-4.839l-16.129,0c-2.674,0 -4.839,2.165 -4.839,4.839c0,2.674 2.165,4.838 4.839,4.838Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.871,41.935l16.129,0c2.674,0 4.839,-2.164 4.839,-4.838c-0,-2.674 -2.165,-4.839 -4.839,-4.839l-16.129,0c-2.674,0 -4.839,2.165 -4.839,4.839c0,2.674 2.165,4.838 4.839,4.838Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.645,32.258l-48.387,0c-2.671,0 -4.839,2.165 -4.839,4.839c0,2.674 2.168,4.838 4.839,4.838l48.387,0c2.671,0 4.839,-2.164 4.839,-4.838c-0,-2.674 -2.168,-4.839 -4.839,-4.839Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingMaschine);
export default __webpack_public_path__ + "static/media/washing_maschine.6013a7bb.svg";
export { ForwardRef as ReactComponent };